import { useApiContext } from '@customink/project-service-react-components';

type ProductProps = {
  styleId?: number;
};

export const useStyle = ({ styleId }: ProductProps) => {
  const api = useApiContext();
  return api.useGetProductByStyleIdQuery({ styleId }, { skip: !styleId });
};
